export class Dress {
  constructor(public name: string, public imgPath: string[],
    public description: string, public price: number, public size: string,
    public index: number, public titlePhoto: string){}
}
